export default {
    methods: {
        getCustomDrawName(drawDate) {
            // Custom name mapping for Luckia games - maps hour to name (ignores minutes)
            const customNames = {
                '08': 'LE BIG',
                '09': 'LE KING', 
                '11': 'LE CAPO',
                '12': 'PATRON',
                '14': 'LE NKAP',
                '15': 'LE BOSS',
                '17': 'SUGAR DADDY',
                '18': 'LE PORTEUR',
                '20': 'PRESIDENT',
                '21': 'LE TITULAIRE'
            };

            // Extract only the hour from draw date, ignore minutes completely
            // Use local time instead of UTC to match the displayed times
            const date = new Date(drawDate);
            const hour = date.getHours().toString().padStart(2, '0');
            
            // Return custom name based on hour only
            // Examples: 8:00 = LE BIG, 9:30 = LE KING, 11:45 = LE CAPO
            return customNames[hour] || `DRAW ${hour}H`;
        },
        
        getDrawDisplayName(drawDate, fallbackName = null) {
            // Get custom name first, fallback to provided name or formatted date
            const customName = this.getCustomDrawName(drawDate);
            if (customName) return customName;
            if (fallbackName) return fallbackName;
            
            // Final fallback to formatted time
            const date = new Date(drawDate);
            return date.toLocaleTimeString('fr-FR', { 
                hour: '2-digit', 
                minute: '2-digit',
                timeZone: 'UTC'
            });
        }
    }
} 